import { isThisYear, isToday } from 'date-fns';
import { format } from 'date-fns/format';
import { ru as russianLocale } from 'date-fns/locale/ru';

export const DATE_FORMAT_FOR_CREATING_REVIEW = 'yyyy-MM-dd';

export const getFormattedDate = (date: string) => {
  const dateFormat = new Date(date);

  if (isToday(dateFormat)) {
    // return formatDistanceToNow(dateFormat, { addSuffix: true, locale: russianLocale });
    return format(dateFormat, 'HH:mm', { locale: russianLocale });
  }

  if (isThisYear(dateFormat)) {
    return format(dateFormat, 'd MMMM', { locale: russianLocale });
  }

  return format(dateFormat, 'd MMMM yyyy', { locale: russianLocale });
};

export const getDate = (datetime: string, f?: string) =>
  format(new Date(datetime), f || 'dd.MM.yyyy', { locale: russianLocale });
